import React, { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  MenuItem,
  Select,
  Avatar,
  Stack,
  Chip,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Menu,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';

const users = [
  {
    name: 'John Doe',
    email: 'john@example.com',
    status: 'Active',
    joinDate: '2024-01-15',
    orders: 12,
  },
  {
    name: 'Jane Smith',
    email: 'jane@example.com',
    status: 'Inactive',
    joinDate: '2024-02-20',
    orders: 8,
  },
  {
    name: 'Mike Johnson',
    email: 'mike@example.com',
    status: 'Active',
    joinDate: '2024-03-10',
    orders: 15,
  },
  {
    name: 'Sarah Wilson',
    email: 'sarah@example.com',
    status: 'Suspended',
    joinDate: '2024-01-05',
    orders: 3,
  },
];

const getStatusColor = (status) => {
  switch (status) {
    case 'Active':
      return { backgroundColor: '#d1fae5', color: '#065f46' }; // green
    case 'Inactive':
    case 'Suspended':
      return { backgroundColor: '#fee2e2', color: '#991b1b' }; // soft red
    default:
      return {};
  }
};

const UsersManagement = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);

  const handleMenuOpen = (event, user) => {
    setAnchorEl(event.currentTarget);
    setSelectedUser(user);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedUser(null);
  };

  const handleAction = (action) => {
    alert(`${action} clicked for user ${selectedUser?.name}`);
    handleMenuClose();
  };

  return (
    <Box sx={{ p: 2 }}>
      <Card sx={{ borderRadius: 2 }}>
        <CardContent>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Box>
              <Typography variant="h5" fontWeight={700}>
                Users Management
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Manage all registered users
              </Typography>
            </Box>
            <Stack direction="row" spacing={2}>
              <Select
                size="small"
                defaultValue=""
                displayEmpty
                sx={{ minWidth: 150, backgroundColor: '#f9f9f9' }}
              >
                <MenuItem value="">Filter by status</MenuItem>
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="Inactive">Inactive</MenuItem>
                <MenuItem value="Suspended">Suspended</MenuItem>
              </Select>
              <Button variant="contained" color="primary" sx={{ textTransform: 'none' }}>
                Add User
              </Button>
            </Stack>
          </Box>

          <TableContainer component={Paper} sx={{ boxShadow: 'none' }}>
            <Table>
             <TableHead>
  <TableRow sx={{ backgroundColor: '#1976d2' }}>
    <TableCell sx={{ color: 'white' }}><strong>User</strong></TableCell>
    <TableCell sx={{ color: 'white' }}><strong>Email</strong></TableCell>
    <TableCell sx={{ color: 'white' }}><strong>Status</strong></TableCell>
    <TableCell sx={{ color: 'white' }}><strong>Join Date</strong></TableCell>
    <TableCell sx={{ color: 'white' }}><strong>Orders</strong></TableCell>
    <TableCell sx={{ color: 'white' }}><strong>Actions</strong></TableCell>
  </TableRow>
</TableHead>

              <TableBody>
                {users.map((user, idx) => (
                  <TableRow key={idx} hover>
                    <TableCell>
                      <Stack direction="row" spacing={2} alignItems="center">
                        <Avatar sx={{ width: 32, height: 32 }} />
                        <Typography>{user.name}</Typography>
                      </Stack>
                    </TableCell>
                    <TableCell>{user.email}</TableCell>
                    <TableCell>
                      <Chip
                        label={user.status}
                        size="small"
                        sx={{
                          fontWeight: 600,
                          borderRadius: '16px',
                          px: 1.5,
                          ...getStatusColor(user.status),
                        }}
                      />
                    </TableCell>
                    <TableCell>{user.joinDate}</TableCell>
                    <TableCell>{user.orders}</TableCell>
                    <TableCell>
                      <IconButton onClick={(e) => handleMenuOpen(e, user)}>
                        <MoreVertIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Action Menu */}
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          >
            <MenuItem onClick={() => handleAction('View Details')}>
              <VisibilityIcon fontSize="small" sx={{ mr: 1 }} />
              View Details
            </MenuItem>
            <MenuItem onClick={() => handleAction('Edit User')}>
              <EditIcon fontSize="small" sx={{ mr: 1 }} />
              Edit User
            </MenuItem>
            <MenuItem onClick={() => handleAction('Delete User')} sx={{ color: '#fe0101bb' }}>
              <DeleteIcon fontSize="small" sx={{ mr: 1, color: '#fe0101bb' }} />
              Delete User 
            </MenuItem>
          </Menu>
        </CardContent>
      </Card>
    </Box>
  );
};

export default UsersManagement;
